import { theme as flatTheme } from './theme.js'

// Transform flat keys into nested objects
function unflattenTheme(flat) {
    const nested = {}

    for (const key in flat) {
        // Replace dashes with dots
        const path = key.split('-')
        let current = nested
        for (let i = 0; i < path.length; i++) {
            const segment = path[i]
            if (i === path.length - 1) {
                current[segment] = flat[key]
            } else {
                current[segment] = current[segment] || {}
                current = current[segment]
            }
        }
    }

    return nested
}

// Creates a recursive proxy to log access
function createThemeProxy(obj, path = []) {
    return new Proxy(obj, {
        get(target, prop) {
            if (typeof prop === 'string') {
                const fullPath = [...path, prop].join('.')

                if (prop in target) {
                    const value = target[prop]
                    return typeof value === 'object' && value !== null
                        ? createThemeProxy(value, [...path, prop])
                        : value
                }

                // 🔍 If the property contains a dash, we try to follow the path
                if (prop.includes('-')) {
                    const segments = prop.split('-')
                    let current = target
                    let validPath = true

                    for (const segment of segments) {
                        if (current && typeof current === 'object' && segment in current) {
                            current = current[segment]
                        } else {
                            validPath = false
                            break
                        }
                    }

                    if (validPath) {
                        // console.log(`⚠️ Accessed via hyphen: ${[...path, ...segments].join('.')}`)
                        return typeof current === 'object' && current !== null
                            ? createThemeProxy(current, [...path, ...segments])
                            : current
                    }
                }

                console.warn(`❌ Not found: ${fullPath}`)
                return undefined
            }

            return target[prop]
        },
    })
}

function colorExists(theme, colorPath) {
    try {
        // Split the colorPath by dots or dashes
        const segments = colorPath.split(/[.-]/)
        let current = theme
        for (const segment of segments) {
            if (current && typeof current === 'object' && segment in current) {
                current = current[segment]
            } else {
                return false
            }
        }
        return typeof current !== 'undefined'
    } catch (error) {
        console.error(`Error checking color existence: ${error.message}`)
        return false
    }
}

const themeNested = unflattenTheme(flatTheme)
const themeProxied = createThemeProxy(themeNested)

export default {
    theme: themeProxied,
    colorExists: (colorPath) => colorExists(themeProxied, colorPath),
}
